<template>
  <div class="assistant-uploader">
    <yxp-upload
      ref="assistantUpload1"
      uploader-id="assistant-upload1"
      theme="tt"
      :limit="limit"
      :max-size="1024"
      :accept="accept"
      :file-list="list"
      btn-name="浏览文件"
      upload-url="/res-file/upload/"
      :upload-mode-type="uploadFromModule"
      class-name="my-btn"
      style="display: none"
      @onFail="onFail"
      @onSucc="onSucc"
      @onChange="doUpload"
    />
    <el-dialog
      id="assistant-upload-dialog"
      title="上传进度"
      top="0"
      :visible.sync="listDialogVisible"
      :modal="false"
      :close-on-click-modal="false"
      :fullscreen="false"
      :modal-append-to-body="true"
    >
      <yxp-upload
        ref="assistantUpload2"
        uploader-id="assistant-upload2"
        theme="tt"
        :limit="limit"
        :max-size="1024"
        :accept="accept"
        :file-list="listAll"
        :file-btn="false"
        btn-name="选择"
        class-name="my-btn"
        @onChange="onChange"
        @onFail="onFail"
        @onSucc="onSucc"
      />
      <div
        slot="title"
        class="header"
      >
        上传进度
        <button
          type="button"
          aria-label="Close"
          class="el-dialog__headerbtn"
          style="right: 50px;"
          @click="zoomUploadDialog"
        >
          <i class="el-dialog__close el-icon el-icon-minus" />
        </button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import BScroll from 'better-scroll';

export default {
    name: 'Uploader',

    props: {
        limit: {
            type: Number,
            default: 1,
        },

        uploadMode: {
            type: String,
            default: 'logo',
        },

        currentType: {
            type: String,
            default: 'school',
        },
    },

    data () {
        return {
            statusArray: [],
            failListArry: [], // 上传失败的资源集合
            index: 0,
            list: [],
            listAdd: [[]],
            listAll: [],
            allProgress: [],
            allProgressAll: 0,
            dialogTableVisible: false,
            wrapper: '',
            scroll: '',
            wrapperAll: '',
            scrollAll: '',
            listDialogVisible: false, // 是否展示上传列表
            accept: '.png,.jpg,.jpeg,', // 允许上传的文件类型
            // uploadFromModule: 'schoolPicture/schoolPicture',
            uploadFromModule: 'resource/wangyeguanli',
            isUploading: false,
        };
    },

    watch: {
        listAdd: {
            handler (newValue, oldValue) {
                console.log('newValue', newValue);
                newValue.forEach((l, i) => {
                    var p = 0;
                    l.forEach(item => {
                        console.log(
                            '%c item.progress' + item.progress,
                            'color:#DC143C;font-size:20px;'
                        );
                        p += parseFloat(item.progress) || 0;
                    });
                    p = p / l.length || 0;
                    this.allProgress[i] = p.toFixed('2') + '%';
                    if (
                        this.statusArray[i] && this.statusArray[i] !== 'succ' && l.every(item => { // 所有资源都出状态，证明上传完成，执行资源转换和资源添加
                            return item.status === 'fail' || item.status === 'succ';
                        })
                    ) {
                        this.statusArray[i] = 'succ';
                        this.$emit('uploadSuccess', l);
                    }
                });
            },
            deep: true,
        },

        listAll: {
            handler (newValue, oldValue) {
                var p = 0;
                newValue.forEach(item => {
                    p += parseFloat(item.progress);
                });
                p = p / newValue.length;
                this.allProgressAll = p.toFixed('2') + '%';
                newValue.forEach(item => { // 失败重传，重新添加到备课方案下
                    if (item.status === 'succ' && item.md5 && this.failListArry.includes(item.md5)) {

                    }
                });
            },
            deep: true,
        },

        currentType: {
            handler (newVal, oldVal) {
                if (newVal === 'agent') {
                    this.uploadFromModule = 'agentPicture/agentPicture';
                } else if (newVal === 'school') {
                    this.uploadFromModule = 'schoolPicture/schoolPicture';
                }
                this.uploadFromModule = 'resource/wangyeguanli';
            },
            immediate: true,
        },
    },

    methods: {
        init (type) {
            if (type === 'powerUp') {
                this.accept = '.png,.jpg,.jpeg,';
                this.$nextTick(() => {
                    if (!this.listAdd[this.index]) {
                        this.listAdd.push([]);
                    }
                    this.list = this.listAdd[this.listAdd.length - 1];
                    // 打开文件选择框
                    document.querySelector('.yxp-uploader .upload-btn').click();
                });
            } else {
                this.accept = '.png,.jpg,.jpeg,';
                this.$nextTick(() => {
                    if (!this.listAdd[this.index]) {
                        this.listAdd.push([]);
                    }
                    this.list = this.listAdd[this.listAdd.length - 1];
                    // 打开文件选择框
                    document.querySelector('.yxp-uploader .upload-btn').click();
                });
            }
        },

        doUpload () {
            let that = this;
            if (this.list && this.list.length <= 0) {
                return;
            }
            for (let i = 0; i < this.list.length; i++) {
                if (this.list[i].rawFile.name.length > 50) {
                    this.$message.error('文件名不能超过50个字符');
                    this.listAdd.splice(this.listAdd.length - 1, 1);
                    return;
                }
                // 判断图片的尺寸
                let files = this.list[i].rawFile;
                let reader = new FileReader();
                reader.onload = function (e) {
                    let data = e.target.result;
                    // 加载图片获取图片真实宽度和高度
                    let image = new Image();
                    image.onload = function () {
                        let width = image.width;
                        let height = image.height;
                        console.log('Image Origin Size:', width, height);
                        if (that.uploadMode === 'logo') {
                            if (width < 200 || height < 50) {
                                that.$message({
                                    type: 'error',
                                    message: '图片必须大于200 * 50px',
                                    duration: 3000,
                                });
                                that.listAdd.splice(that.listAdd.length - 1, 1);
                                return false;
                            } else {
                                that.statusArray.push('process');
                                that.dialogTableVisible = false; // 关闭弹窗
                                that.isUploading = true;
                                that.listAll = that.$refs['assistantUpload1'].submit(); // 执行上传
                                that.showProgress(); // 显示上传进度
                                that.index++;
                                that.accept = '.png,.jpg,.jpeg,';
                            }
                        } else if (['teacher', 'student', 'teacherBoot', 'studentBoot', 'powerUp'].includes(that.uploadMode)) {
                            if (that.uploadMode === 'powerUp') {
                                that.accept = '.png,.jpg,.jpeg,';
                            } else {
                                that.accept = '.png,.jpg,.jpeg,';
                            }
                            if (!['powerUp'].includes(that.uploadMode) && (width < 3072 || height < 1536)) {
                                that.$message({
                                    type: 'error',
                                    message: '图片必须大于3072 * 1536px',
                                    duration: 3000,
                                });
                                that.listAdd.splice(that.listAdd.length - 1, 1);
                                return false;
                            } else {
                                that.statusArray.push('process');
                                that.dialogTableVisible = false; // 关闭弹窗
                                that.isUploading = true;
                                that.listAll = that.$refs['assistantUpload1'].submit(); // 执行上传
                                that.showProgress(); // 显示上传进度
                                that.index++;
                            }
                        }
                    };
                    image.onerror = () => {
                        that.isUploading = false;
                        that.listAdd.splice(that.listAdd.length - 1, 1);
                        that.$message.error('图片加载失败');
                    };
                    image.src = data;
                };
                reader.readAsDataURL(files);
            }
        },

        onChange (list) {
            this.$nextTick(() => {
                this.scroll.refresh();
            });
        },

        // 上传成功的回调
        onSucc (file) {
            console.log(file, '/success');
            this.isUploading = false;
        },

        // 上传失败的回调
        onFail (file) {
            console.log(file, '/fail');
            this.isUploading = false;
            if (file.status === 'fail') {
                this.$message.error(file.errMsg);
            }
        },

        add () {
            if (!this.listAdd[this.index]) {
                this.listAdd.push([]);
            }
            this.list = this.listAdd[this.index];
            this.dialogTableVisible = true;
            this.$nextTick(() => {
                if (!this.scroll) {
                    this.wrapper = this.$refs['assistantUpload1'].$refs.uploadList.$el;
                    this.scroll = new BScroll(this.wrapper, {
                        scrollbar: true,
                        click: true,
                        // wheel: true,
                    });
                }
            });
        },

        // 显示上传进度
        showProgress () {
            this.listDialogVisible = true;
            this.$nextTick(() => {
                if (!this.scrollAll) {
                    this.wrapperAll = this.$refs['assistantUpload2'].$refs.uploadList.$el;
                    this.scrollAll = new BScroll(this.wrapperAll, {
                        scrollbar: true,
                        click: true,
                        // wheel: true,
                    });
                } else {
                    this.scrollAll.refresh();
                }
            });
        },

        // 最小化上传弹窗
        zoomUploadDialog () {
            document.querySelector('#assistant-upload-dialog .el-dialog__body').classList.toggle('hide');
        },
    },
};
</script>

<style scoped lang="scss">
.block {
  margin-bottom: 20px;
}
.login {
  font-size: 14px;
}
.yxp-uploader .btn.upload-btn {
  width: 80px;
  border: none;
  padding: 9px 16px;
  border-radius: 4px;
  cursor: pointer;
  background-color: #2fd095;
  color: #fff;
  outline: none;
}
.upload-btn:hover {
  background-color: rgb(28, 151, 106);
}
.a {
  height: 100px;
  overflow: hidden;
  position: relative;
}
.list-wrapper {
  height: 200px;
  overflow: hidden;
  position: relative;
}
</style>
<style lang="scss">
#assistant-upload-dialog {
  position: relative;
  overflow: inherit;
  .el-dialog__header {
    padding-top: 20px;
    border-bottom: 1px solid #2ed095;
  }
  .el-dialog {
    position: fixed;
    right: 22px;
    bottom: 1px;
    margin-bottom: 0;
    width: 632px;
    min-height: auto;
    height: auto;
  }
  .el-dialog__title {
    color: #2ed095;
    font-size: 14px;
  }
  .el-dialog__body {
    display: block;
    padding: 0px 5px;
  }
  .el-dialog__body.hide {
    display: none;
  }
  .header {
    font-size: 14px;
    color: #2ed095;
  }
  .yxp-uploader-list {
    max-height: 210px;
    overflow-y: auto;
  }
}
</style>
